<template>
  <div>
    <b-modal
      id="templateCreateModal"
      :title="title"
      size="lg"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Vista"
      cancel-title="Hætta við"
      @ok.prevent="validateBeforeSubmit"
      :ok-disabled="loading || uploading"
      ref="createModal"
    >
      <div>
        <b-form @submit.prevent="validateBeforeSubmit" novalidate>
          <b-form-group
            label="Texti:"
            label-for="text"
            :state="submitted && errors.has('text') ? false : ''"
            :invalid-feedback="errors.first('text')"
            description="Efni tilkynningarinnar"
          >
            <b-form-textarea
              id="text"
              name="text"
              type="text"
              v-model="form.text"
              required
              :state="submitted && errors.has('text') ? false : ''"
              v-validate="'required'"
              data-vv-as="texti"
            ></b-form-textarea>
          </b-form-group>
          <div>
            <strong>Bæta við breytum: </strong>
            <a
              @click.prevent="appendVariable(variable)"
              v-for="variable in variables"
              :key="variable"
              class="d-block"
              style="cursor: pointer"
            >
              {{ variable }}
            </a>
          </div>
          <!-- Viðhengi -->
          <div class="mt-3">
            <strong>Viðhengi:</strong>
            <div class="mt-1">
              <email-attachment-upload v-model="form.attachmentIds" :uploading.sync="uploading" :initial-files="initialFiles" />
            </div>
          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import core from '@/api/core';
import { djangoErrorsToVee } from '@/utils';
import EmailAttachmentUpload from '@/components/EmailAttachmentUpload.vue';

export default {
  name: 'template-edit-modal',
  components: {
    EmailAttachmentUpload,
  },
  data() {
    return {
      loading: false,
      submitted: false,
      errorList: [],
      title: '',
      templateId: '',
      variables: [
        '#NEMANDI#',
        '#KENNITALA#',
        '#DAGS#',
        '#TIMABIL#',
        '#STARFSTIMABIL#',
        '#STARFSSTADUR#',
        '#STARFSSTADUR_SAMÞYKKT#',
        '#HOPUR#',
      ],
      form: {
        type: '',
        typeName: '',
        text: '',
        attachmentIds: [],
      },
      initialFiles: [],
      uploading: false,
    };
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const response = await core.templateDetail(this.templateId);
        this.form.text = response.data.text;
        this.form.attachmentIds = (response.data.attachments || []).map(a => a.id);
        this.initialFiles = (response.data.attachments || []).map(a => ({
          uuid: a.id,
          filename: a.filename,
          url: a.url,
        }));
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    appendVariable(variable) {
      this.form.text = `${this.form.text}${variable}`;
    },
    async validateBeforeSubmit() {
      try {
        this.submitted = true;
        this.errorList = [];
        // Engar villur í formi.
        try {
          this.loading = true;
          if (this.templateId) {
            await core.templateUpdate(this.templateId, {
              type: this.form.type,
              text: this.form.text,
              attachment_ids: this.form.attachmentIds,
            });
            this.displaySuccess(`Tilkynningu fyrir „${this.form.typeName}" hefur verið breytt.`);
          } else {
            await core.templateCreate({
              type: this.form.type,
              text: this.form.text,
              attachment_ids: this.form.attachmentIds,
            });
            this.displaySuccess(`Tilkynning fyrir „${this.form.typeName}" hefur verið stofnuð.`);
          }
          this.$emit('successful', {});
          this.$refs.createModal.hide();
        } catch (e) {
          // Aðgerð mistókst.
          this.failed = true;
          this.$log.debug(e);
          if (e.response && e.response.status === 400) {
            djangoErrorsToVee(e.response.data, this.errors, this.errorList);
          } else {
            this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
          }
        }
      } catch (e) {
        // Villur í formi.
        this.$log.debug(e);
      } finally {
        this.loading = false;
      }
    },
    show(template) {
      this.templateId = null;
      this.form.text = '';
      this.form.type = template.type;
      this.form.typeName = template.name;
      this.title = template.name;
      this.submitted = false;
      this.loading = false;
      this.form.attachmentIds = [];
      this.initialFiles = [];
      if (template.id) {
        this.templateId = template.id;
        this.load();
      }
      this.$refs.createModal.show();
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
<style lang="scss"></style>
